(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-03-before-after-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dgDentureReviewsMarqueeInitialized) return;
    window.__dgDentureReviewsMarqueeInitialized = true;

    const instances = new WeakMap();
    const modulo = (value, length) => ((value % length) + length) % length;

    function init(root) {
      if (!root || instances.has(root)) return;
      const track = root.querySelector('[data-dg-review-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('[data-dg-review-card]'));
      if (!cards.length) return;
      const dots = Array.from(root.querySelectorAll('[data-dg-review-dot]'));
      const previous = root.querySelector('[data-dg-review-prev]');
      const next = root.querySelector('[data-dg-review-next]');
      const controls = root.querySelector('.dg-review-controls');
      const controller = new AbortController();
      const autoplay = root.dataset.dgAutoplay === 'true' && cards.length > 1;
      const pauseOnHover = root.dataset.dgPauseHover === 'true';
      const speed = Math.max(10, Math.min(80, Number(root.dataset.dgScrollSpeed) || 35));
      let step = 0;
      let cycleWidth = 0;
      let updateFrame = 0;
      let autoplayFrame = 0;
      let lastTime = 0;
      let pauseUntil = 0;
      let hovered = false;
      let focused = false;
      let dragging = false;
      let blockSelected = false;

      function rebuild() {
        const oldPhase = cycleWidth ? modulo(track.scrollLeft, cycleWidth) / cycleWidth : 0;
        track.querySelectorAll('[data-dg-review-clone]').forEach((clone) => clone.remove());
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].getBoundingClientRect().width + gap;
        cycleWidth = Math.max(1, cards.length * step);
        const repetitions = Math.ceil(track.clientWidth / cycleWidth) + 1;
        const fragment = document.createDocumentFragment();
        for (let copy = 0; copy < repetitions; copy++) {
          cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.removeAttribute('data-dg-review-card');
            Array.from(clone.attributes).forEach((attribute) => {
              if (attribute.name.startsWith('data-shopify-')) clone.removeAttribute(attribute.name);
            });
            clone.setAttribute('data-dg-review-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            fragment.appendChild(clone);
          });
        }
        track.appendChild(fragment);
        track.scrollLeft = oldPhase * cycleWidth;
        update();
      }

      function currentIndex() {
        return step ? Math.round(modulo(track.scrollLeft, cycleWidth) / step) % cards.length : 0;
      }

      function update() {
        const current = currentIndex();
        dots.forEach((dot, index) => {
          dot.hidden = false;
          dot.classList.toggle('is-active', index === current);
          if (index === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (controls) controls.hidden = cards.length < 2;
        if (previous) previous.disabled = cards.length < 2;
        if (next) next.disabled = cards.length < 2;
      }

      function goTo(index) {
        if (cards.length < 2 || !step) return;
        const target = modulo(index, cards.length);
        const phase = modulo(track.scrollLeft, cycleWidth);
        let delta = target * step - phase;
        if (delta > cycleWidth / 2) delta -= cycleWidth;
        if (delta < -cycleWidth / 2) delta += cycleWidth;
        if (track.scrollLeft + delta < 0) track.scrollLeft += cycleWidth;
        pauseUntil = performance.now() + 5000;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
        window.setTimeout(update, 550);
      }

      root.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-dg-review-dot]');
        if (dot) { goTo(Number(dot.dataset.dgReviewDot)); return; }
        if (event.target.closest('[data-dg-review-prev]')) goTo(currentIndex() - 1);
        if (event.target.closest('[data-dg-review-next]')) goTo(currentIndex() + 1);
      }, { signal: controller.signal });
      track.addEventListener('scroll', () => {
        if (updateFrame) cancelAnimationFrame(updateFrame);
        updateFrame = requestAnimationFrame(update);
      }, { passive: true, signal: controller.signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(currentIndex() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(currentIndex() - 1); }
      }, { signal: controller.signal });
      track.addEventListener('pointerenter', (event) => { if (pauseOnHover && event.pointerType === 'mouse') hovered = true; }, { signal: controller.signal });
      track.addEventListener('pointerleave', (event) => { if (pauseOnHover && event.pointerType === 'mouse') hovered = false; }, { signal: controller.signal });
      root.addEventListener('focusin', () => { focused = true; }, { signal: controller.signal });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) focused = false; }, { signal: controller.signal });
      track.addEventListener('pointerdown', () => { dragging = true; pauseUntil = performance.now() + 5000; }, { signal: controller.signal });
      window.addEventListener('pointerup', () => { dragging = false; }, { signal: controller.signal });
      window.addEventListener('pointercancel', () => { dragging = false; }, { signal: controller.signal });

      let measuredWidth = track.clientWidth;
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
        if (track.clientWidth !== measuredWidth) { measuredWidth = track.clientWidth; rebuild(); }
      }) : null;
      const onResize = () => {
        if (track.clientWidth !== measuredWidth) { measuredWidth = track.clientWidth; rebuild(); }
      };
      if (observer) observer.observe(track);
      else window.addEventListener('resize', onResize, { signal: controller.signal });

      function tick(time) {
        const elapsed = lastTime ? Math.min(64, time - lastTime) : 0;
        lastTime = time;
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!hovered && !focused && !dragging && !blockSelected && !document.hidden && !reducedMotion && time > pauseUntil) {
          let nextPosition = track.scrollLeft + speed * elapsed / 1000;
          if (nextPosition >= cycleWidth) nextPosition = modulo(nextPosition, cycleWidth);
          track.scrollLeft = nextPosition;
        }
        autoplayFrame = requestAnimationFrame(tick);
      }

      rebuild();
      if (autoplay) autoplayFrame = requestAnimationFrame(tick);
      instances.set(root, {
        goTo,
        cards,
        selectBlock(index) { blockSelected = true; goTo(index); },
        deselectBlock() { blockSelected = false; pauseUntil = performance.now() + 3000; },
        selectSection() { pauseUntil = performance.now() + 1000; },
        destroy() {
          controller.abort();
          if (updateFrame) cancelAnimationFrame(updateFrame);
          if (autoplayFrame) cancelAnimationFrame(autoplayFrame);
          if (observer) observer.disconnect();
        }
      });
    }

    document.querySelectorAll('[data-dg-review-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-dg-review-section]').forEach(init);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-dg-review-section]').forEach((root) => {
        const instance = instances.get(root);
        if (instance) instance.destroy();
        instances.delete(root);
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-dg-review-card]');
      const root = card && card.closest('[data-dg-review-section]');
      const instance = root && instances.get(root);
      if (instance) instance.selectBlock(instance.cards.indexOf(card));
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target.closest('[data-dg-review-section]');
      const instance = root && instances.get(root);
      if (instance) instance.deselectBlock();
    });
    document.addEventListener('shopify:section:select', (event) => {
      event.target.querySelectorAll('[data-dg-review-section]').forEach((root) => {
        const instance = instances.get(root);
        if (instance) instance.selectSection();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-06-results-and-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dgDentureResultsReady) return;
    window.__dgDentureResultsReady = true;

    function updateDots(section) {
      const track = section.querySelector('[data-dg-results-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('.dg-results-video-card'));
      const dots = Array.from(section.querySelectorAll('[data-dg-results-dot]'));
      if (!cards.length) return;
      let closest = 0;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const delta = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (delta < distance) { distance = delta; closest = index; }
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === closest ? 'true' : 'false'));
    }

    function bind(section) {
      const track = section.querySelector('[data-dg-results-track]');
      if (!track || track.dataset.dgResultsBound) return;
      track.dataset.dgResultsBound = 'true';
      track.addEventListener('scroll', () => requestAnimationFrame(() => updateDots(section)), { passive: true });
      updateDots(section);
    }

    function bindAll() {
      document.querySelectorAll('.dg-denture-results').forEach(bind);
    }

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('[data-dg-results-arrow]');
      if (arrow) {
        const section = arrow.closest('.dg-denture-results');
        const track = section && section.querySelector('[data-dg-results-track]');
        const card = track && track.querySelector('.dg-results-video-card');
        if (track && card) {
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * (arrow.dataset.dgResultsArrow === 'next' ? 1 : -1), behavior: 'smooth' });
        }
        return;
      }
      const dot = event.target.closest('[data-dg-results-dot]');
      if (dot) {
        const section = dot.closest('.dg-denture-results');
        const track = section && section.querySelector('[data-dg-results-track]');
        const card = track && track.querySelectorAll('.dg-results-video-card')[Number(dot.dataset.dgResultsDot)];
        if (track && card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        return;
      }
      const play = event.target.closest('[data-dg-results-play]');
      if (play) {
        const section = play.closest('.dg-denture-results');
        const video = play.closest('.dg-results-video-card').querySelector('video');
        if (!video) return;
        section.querySelectorAll('video').forEach((other) => { if (other !== video) other.pause(); });
        video.play().catch(() => {});
      }
    });
    document.addEventListener('play', (event) => {
      if (event.target.matches && event.target.matches('.dg-denture-results video')) event.target.closest('.dg-results-video-card').classList.add('is-playing');
    }, true);
    document.addEventListener('pause', (event) => {
      if (event.target.matches && event.target.matches('.dg-denture-results video')) event.target.closest('.dg-results-video-card').classList.remove('is-playing');
    }, true);
    document.addEventListener('ended', (event) => {
      if (event.target.matches && event.target.matches('.dg-denture-results video')) event.target.closest('.dg-results-video-card').classList.remove('is-playing');
    }, true);
    document.addEventListener('DOMContentLoaded', bindAll);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.dg-denture-results');
      if (section) bind(section);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.dg-results-video-card');
      if (!card) return;
      const track = card.closest('[data-dg-results-track]');
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
    bindAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-07-customer-photo-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dgDentureMarqueeReady) return;
    window.__dgDentureMarqueeReady = true;
    const instances = new WeakMap();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(section) {
      if (instances.has(section)) return;
      const viewport = section.querySelector('[data-dg-marquee-viewport]');
      const groups = section.querySelectorAll('[data-dg-marquee-group]');
      if (!viewport || groups.length !== 3) return;

      let cycle = 0;
      let lastTime = 0;
      let frameId = 0;
      let interacting = false;
      let pauseUntil = 0;
      let inView = true;
      const speed = Number(section.dataset.speed) || 50;
      const autoplay = section.dataset.autoplay === 'true';
      const pauseOnHover = section.dataset.pauseHover === 'true';

      function measure() {
        cycle = groups[1].offsetLeft - groups[0].offsetLeft;
        if (cycle > 0) viewport.scrollLeft = cycle;
      }
      function normalize() {
        if (!cycle || interacting) return;
        if (viewport.scrollLeft < cycle * .5) viewport.scrollLeft += cycle;
        if (viewport.scrollLeft > cycle * 1.5) viewport.scrollLeft -= cycle;
      }
      function tick(time) {
        const delta = lastTime ? Math.min(time - lastTime, 100) : 0;
        lastTime = time;
        if (autoplay && !reduceMotion.matches && !document.hidden && inView && !interacting && time > pauseUntil && !(pauseOnHover && section.matches(':hover')) && cycle > viewport.clientWidth) {
          viewport.scrollLeft += speed * delta / 1000;
          if (viewport.scrollLeft >= cycle * 2) viewport.scrollLeft -= cycle;
        }
        frameId = requestAnimationFrame(tick);
      }
      function onPointerDown() { interacting = true; }
      function onPointerEnd() {
        interacting = false;
        pauseUntil = performance.now() + 2600;
        normalize();
      }
      function onWheel() { pauseUntil = performance.now() + 2600; }
      function onKeydown() { pauseUntil = performance.now() + 2600; }

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointerup', onPointerEnd);
      viewport.addEventListener('pointercancel', onPointerEnd);
      viewport.addEventListener('wheel', onWheel, { passive: true });
      viewport.addEventListener('keydown', onKeydown);

      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(viewport);
      resizeObserver.observe(groups[1]);
      const intersectionObserver = new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
      });
      intersectionObserver.observe(section);
      measure();
      frameId = requestAnimationFrame(tick);

      instances.set(section, {
        scrollToBlock(block) {
          pauseUntil = performance.now() + 12000;
          viewport.scrollTo({ left: block.offsetLeft - groups[1].offsetLeft + cycle, behavior: 'smooth' });
        },
        destroy() {
          cancelAnimationFrame(frameId);
          resizeObserver.disconnect();
          intersectionObserver.disconnect();
          viewport.removeEventListener('pointerdown', onPointerDown);
          viewport.removeEventListener('pointerup', onPointerEnd);
          viewport.removeEventListener('pointercancel', onPointerEnd);
          viewport.removeEventListener('wheel', onWheel);
          viewport.removeEventListener('keydown', onKeydown);
          instances.delete(section);
        }
      });
    }

    function setupAll() {
      document.querySelectorAll('[data-dg-marquee]').forEach(setup);
    }
    document.addEventListener('DOMContentLoaded', setupAll);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-dg-marquee]') ? event.target : event.target.querySelector('[data-dg-marquee]');
      if (section) setup(section);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches('[data-dg-marquee]') ? event.target : event.target.querySelector('[data-dg-marquee]');
      const instance = section && instances.get(section);
      if (instance) instance.destroy();
    });
    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('.dg-marquee-group:not([aria-hidden]) .dg-marquee-item');
      if (!block) return;
      const section = block.closest('[data-dg-marquee]');
      const instance = instances.get(section);
      if (instance) instance.scrollToBlock(block);
    });
    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-11-offer-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dgDentureCountdownReady) return;
    window.__dgDentureCountdownReady = true;
    const timers = new Map();
    const deadlinePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;

    function setup(section) {
      if (timers.has(section)) return;
      const value = (section.dataset.deadline || '').trim();
      const deadline = deadlinePattern.test(value) ? Date.parse(value) : NaN;
      const nodes = {
        days: section.querySelector('[data-dg-countdown-days]'),
        hours: section.querySelector('[data-dg-countdown-hours]'),
        minutes: section.querySelector('[data-dg-countdown-minutes]'),
        seconds: section.querySelector('[data-dg-countdown-seconds]')
      };
      if (Object.values(nodes).some((node) => !node)) return;

      function update() {
        const remaining = Number.isFinite(deadline) ? Math.max(0, deadline - Date.now()) : 0;
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor(totalSeconds % 86400 / 3600),
          minutes: Math.floor(totalSeconds % 3600 / 60),
          seconds: totalSeconds % 60
        };
        for (const key of Object.keys(values)) nodes[key].textContent = String(values[key]);
        if (remaining === 0 && timers.has(section)) {
          clearInterval(timers.get(section));
          timers.set(section, null);
        }
      }

      update();
      if (Number.isFinite(deadline) && deadline > Date.now()) {
        timers.set(section, setInterval(update, 1000));
      } else {
        timers.set(section, null);
      }
    }

    function setupAll() {
      document.querySelectorAll('[data-dg-denture-countdown]').forEach(setup);
    }
    document.addEventListener('DOMContentLoaded', setupAll);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-dg-denture-countdown]') ? event.target : event.target.querySelector('[data-dg-denture-countdown]');
      if (section) setup(section);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches('[data-dg-denture-countdown]') ? event.target : event.target.querySelector('[data-dg-denture-countdown]');
      if (section && timers.has(section)) {
        clearInterval(timers.get(section));
        timers.delete(section);
      }
    });
    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
